import React, { Fragment, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import State from "../viewer2d/state";
import { ReactSVGPanZoom, setPointOnViewerCenter } from "react-svg-pan-zoom";
import { Catalog } from "../../catalog/catalog";
import { provideAreaOfPolygon } from "../../utils/geometry";
import Item from "../viewer2d/item";

import { List } from "immutable";
// import { usePDF } from "react-to-pdf";
const ViewerFinish = ({ state, width, height, catalog, componentRef }) => {
  let defaultState = {
    a: 0.5,
    b: 0,
    SVGWidth: 30000,
    c: 0,
    mode: "idle",
    d: 0.5,
    e: -6814,
    f: -3505,
    miniatureOpen: true,
    SVGHeight: 20000,
    pinchPointDistance: null,
    scaleFactorMax: 5,
    lastAction: null,
    viewerWidth: 1336,
    startX: null,
    startY: null,
    version: 2,
    focus: false,
    scaleFactorMin: 0.14,
    viewerHeight: 727.2000122070312,
    prePinchMode: null,
    endX: null,
    endY: null,
  };
  const [viewerState, setViewerState] = useState(defaultState);
  let onChangeValue = (value) => {
    let valueE = value.e;
    let valueF = value.f;
    if (value.e >= -10 || value.e <= -2930) {
      valueE = value.e;
    }
    if (value.f >= 0 || value.f <= -2000) {
      valueF = value.f;
    }
    setViewerState({ ...value, a: value.a, e: valueE, f: valueF });
    // projectActions.updateZoomScale(value.a);
  };
  let layers = state.getIn(["scene", "layers"]);
  let selectedLayer = state.getIn(["scene", "selectedLayer"]);
  let layer = state.getIn(["scene", "layers", selectedLayer]);
  let areas = state.getIn(["scene", "layers", selectedLayer, "areas"]);
  let safetysymbols = layer
    .getIn(["items"])
    .filter((item) => item.type.includes("firesafety"));
  safetysymbols = safetysymbols.size
    ? safetysymbols.reduce((acc, current) => {
        if (!acc.some((item) => item.type === current.type)) {
          acc = acc.push(current);
        }
        return acc;
      }, new List())
    : safetysymbols;
  let evacuationPlan = state.get("evacuationPlan");
  // const styles = StyleSheet.create({
  //   page: {
  //     flexDirection: "row",
  //     backgroundColor: "#E4E4E4",
  //   },
  //   section: {
  //     margin: 10,
  //     padding: 10,
  //     flexGrow: 1,
  //   },
  // });

  return (
    <Fragment>
      {/* <button  onClick={() => handleDownload()}>click to generate</button> */}
      <div
        ref={componentRef}
        width={width}
        height={height}
        data-bs-floorId={`floorplan-${selectedLayer}-${Date.now().toString()}`}
        style={{ overflow: "auto" }}
      >
        {evacuationPlan ? (
          <div>
            <div style={{ textAlign: "center", background: "#08b763" }}>
              <p
                style={{
                  fontSize: "31px",
                  fontWeight: "800",
                  margin: "0",
                  color: "white",
                }}
              >
                FIRE EVACUATION PLAN
              </p>
            </div>
            <div style={{ display: "flex" }}>
              <div
                style={{
                  flex: "15%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div style={{ background: "#2196f3", color: "white", flex: 1 }}>
                  <p style={{ padding: 10, margin: 0, fontSize: "12px" }}>
                    <span>
                      <u>
                        <b>IN CASE OF FIRE</b>
                      </u>
                    </span>{" "}
                    <br />
                    <br />
                    Immediately raise the alarm by operating the nearest RED
                    break glass call point and:
                    <ul style={{ paddingLeft: 20 }}>
                      <li>
                        Dial 999 to confirm the location and details of the fire
                      </li>
                      <li>
                        Close all doors and windows in the immediate vicinity{" "}
                      </li>
                      <li>
                        Commence evacuation using the nearest, safest evacuation
                        route.
                      </li>
                    </ul>
                  </p>
                </div>
                <div style={{ background: "#08b763", color: "white", flex: 1 }}>
                  <p style={{ padding: 10, margin: 0, fontSize: "12px" }}>
                    <br />
                    <p style={{ margin: 0 }}>
                      <b>ON HEARING THE FIRE ALARM</b>
                    </p>
                    <br />
                    <span>
                      <u>
                        <b>A Continuous Sound Means</b>
                      </u>
                    </span>
                    <br />
                    <br />
                    The alarm has been activated in your area. Investigate your
                    area and evacuate as necessary.
                    <br />
                    <br />
                    <span>
                      <u>
                        <b>An Intermittent Sound Means</b>
                      </u>
                    </span>
                    <br />
                    <br />
                    The alarm was activated in the adjacent area. Check your
                    area for signs of a fire. Identify the location of the alarm
                    zone and prepare your area as necessary in case of emergency
                    evacuation.
                  </p>
                </div>
                <div
                  style={{
                    textAlign: "center",
                    background: "#da2727",
                    color: "white",
                    flex: 1,
                  }}
                >
                  <p style={{ padding: 10, margin: 0, fontSize: "12px" }}>
                    <br />
                    <p style={{ margin: 0 }}>
                      <b>EMERGENCY NUMBER</b>
                    </p>
                    <br />
                    <p style={{ margin: 0, fontSize: 24 }}>
                      <b>999</b>
                    </p>
                  </p>
                </div>
              </div>
              <div style={{ flex: "85%" }}>
                <div style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>
                    {layer.get("visibleName").toUpperCase()}
                  </p>
                  <p style={{ margin: 0 }}>
                    {parseFloat(
                      areas
                        .toArray()
                        .reduce(
                          (accumulator, area) =>
                            parseFloat(accumulator) +
                            parseFloat(provideAreaOfPolygon(area, layer)),
                          0.0
                        )
                    ).toFixed(2)}
                    m{String.fromCharCode(0xb2)}({" "}
                    {parseFloat(
                      areas
                        .toArray()
                        .reduce(
                          (accumulator, area) =>
                            parseFloat(accumulator) +
                            parseFloat(provideAreaOfPolygon(area, layer)),
                          0.0
                        )
                    ).toFixed(2) * 10.764}
                    ft{String.fromCharCode(0xb2)}) approx.
                  </p>
                </div>
                <ReactSVGPanZoom
                  value={viewerState}
                  onChangeValue={onChangeValue}
                  tool="auto"
                  preventPanOutside={true}
                  disableDoubleClickZoomWithToolAuto={true}
                  detectAutoPan={false}
                  scaleFactorMax={5}
                  scaleFactorMin={0.14}
                  miniaturePosition="none"
                  toolbarPosition="none"
                  width={"100%"}
                  height={"95vh"}
                >
                  <svg>
                    <g
                      style={
                        {
                          // strokeLinejoin: "round",
                        }
                      }
                    >
                      <State
                        state={state}
                        catalog={catalog}
                        showGuides={false}
                      />
                    </g>
                  </svg>
                </ReactSVGPanZoom>

                {/* <div style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>
                    {layer.get("visibleName").toUpperCase()}
                  </p> */}
                  {/* <p style={{ margin: 0 }}>
                    {parseFloat(
                      areas
                        .toArray()
                        .reduce(
                          (accumulator, area) =>
                            parseFloat(accumulator) +
                            parseFloat(provideAreaOfPolygon(area, layer)),
                          0.0
                        )
                    ).toFixed(2)}
                    m{String.fromCharCode(0xb2)}({" "}
                    {parseFloat(
                      areas
                        .toArray()
                        .reduce(
                          (accumulator, area) =>
                            parseFloat(accumulator) +
                            parseFloat(provideAreaOfPolygon(area, layer)),
                          0.0
                        )
                    ).toFixed(2) * 10.764}
                    ft{String.fromCharCode(0xb2)}) approx.
                  </p> */}
                {/* </div> */}
              </div>
              <div
                style={{
                  width: "71vw",
                  height: "25vh",
                  overflow: "auto",
                  position: "absolute",
                  bottom: "3px",
                  right: "10px",
                  border: "1px solid",
                  // padding: "10px",
                  backgroundColor: "white",
                }}
              >
                <p
                  style={{ textAlign: "left", fontSize: "13px", margin: "1px" }}
                >
                  Legend
                </p>
                <hr />
                <div
                  style={{
                    display: "flex",
                    /* width: 200px; */
                    flexWrap: "wrap",
                  }}
                >
                  {safetysymbols.valueSeq().map((symbol) => (
                    <div
                      style={{
                        width: "60px",
                        display: "flex",
                        flexDirection: "column",
                        // justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        rowGap: "3px",
                      }}
                    >
                      <img
                        src={require(`../../assets/firesafety/${symbol.type.replace(
                          "firesafety-",
                          ""
                        )}/legend.png`)}
                        alt=""
                        style={{ width: "50%" }}
                      />
                      <p
                        style={{
                          margin: 0,
                          fontSize: "11px",
                          paddingLeft: "5px",
                        }}
                      >
                        {symbol.name}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <Fragment>
            <div style={{ textAlign: "center" }}>
              <p style={{ margin: 0 }}>
                {layer.get("visibleName").toUpperCase()}
              </p>
              <p style={{ margin: 0 }}>
                {parseFloat(
                  areas
                    .toArray()
                    .reduce(
                      (accumulator, area) =>
                        parseFloat(accumulator) +
                        parseFloat(provideAreaOfPolygon(area, layer)),
                      0.0
                    )
                ).toFixed(2)}
                m{String.fromCharCode(0xb2)}({" "}
                {parseFloat(
                  areas
                    .toArray()
                    .reduce(
                      (accumulator, area) =>
                        parseFloat(accumulator) +
                        parseFloat(provideAreaOfPolygon(area, layer)),
                      0.0
                    )
                ).toFixed(2) * 10.764}
                ft{String.fromCharCode(0xb2)}) approx.
              </p>
            </div>
            <div style={{ display: "flex" }}>
              <ReactSVGPanZoom
                value={viewerState}
                onChangeValue={onChangeValue}
                tool="auto"
                preventPanOutside={true}
                disableDoubleClickZoomWithToolAuto={true}
                detectAutoPan={false}
                scaleFactorMax={5}
                scaleFactorMin={0.14}
                miniaturePosition="none"
                toolbarPosition="none"
                width={"100%"}
                height={"95vh"}
              >
                <svg>
                  <g
                    style={
                      {
                        // strokeLinejoin: "round",
                      }
                    }
                  >
                    <State state={state} catalog={catalog} showGuides={false} />
                  </g>
                </svg>
              </ReactSVGPanZoom>
              <div
                style={{
                  width: "80vw",
                  height: "25vh",
                  overflow: "auto",
                  position: "absolute",
                  bottom: "3px",
                  right: "10px",
                  border: "1px solid",
                  // padding: "10px",
                  backgroundColor: "white",
                }}
              >
                <p
                  style={{ textAlign: "left", fontSize: "13px", margin: "1px" }}
                >
                  Legend
                </p>
                <hr />
                <div
                  style={{
                    display: "flex",
                    /* width: 200px; */
                    flexWrap: "wrap",
                  }}
                >
                  {safetysymbols.valueSeq().map((symbol) => (
                    <div
                      style={{
                        width: "60px",
                        display: "flex",
                        flexDirection: "column",
                        // justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        rowGap: "3px",
                      }}
                    >
                      <img
                        src={require(`../../assets/firesafety/${symbol.type.replace(
                          "firesafety-",
                          ""
                        )}/legend.png`)}
                        alt=""
                        style={{ width: "50%" }}
                      />
                      <p
                        style={{
                          margin: 0,
                          fontSize: "11px",
                          paddingLeft: "5px",
                        }}
                      >
                        {symbol.name}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Fragment>
        )}
      </div>
    </Fragment>
  );
};
ViewerFinish.propTypes = {
  catalog: PropTypes.instanceOf(Catalog),
};
export default ViewerFinish;
